import React from 'react';

/**
 * Widget icon component for container items
 */
export const WidgetIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
    <rect x="2" y="2" width="5" height="5" rx="1" stroke="#6B788C" strokeWidth="1.5"/>
    <rect x="9" y="2" width="5" height="5" rx="1" stroke="#6B788C" strokeWidth="1.5"/>
    <rect x="2" y="9" width="5" height="5" rx="1" stroke="#6B788C" strokeWidth="1.5"/>
    <rect x="9" y="9" width="5" height="5" rx="1" stroke="#6B788C" strokeWidth="1.5"/>
  </svg>
);

/**
 * Container icon component for nested containers
 */
export const ContainerIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
    <rect x="1" y="2" width="14" height="12" rx="1" stroke="#6B788C" strokeWidth="1.5"/>
    <line x1="1" y1="5" x2="15" y2="5" stroke="#6B788C" strokeWidth="1.5"/>
  </svg>
);

/**
 * Delete icon component for delete actions
 */
export const DeleteIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2 4h12M5.333 4V2.667a1.333 1.333 0 011.334-1.334h2.666a1.333 1.333 0 011.334 1.334V4m2 0v9.333a1.333 1.333 0 01-1.334 1.334H4.667a1.333 1.333 0 01-1.334-1.334V4h9.334z"
      stroke="#DC2626"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
